/**
 * Ryan O'Dowd
 * 2025-01-12
 * © Copyright 2025 Oakwood Software Consulting, Inc. All Rights Reserved.
 */

const getStyles = ({windowHeight, safeAreaInsets}) => {
  return {
    container: {
      flexShrink: 1,
      maxWidth: '100%',
      maxHeight: windowHeight - safeAreaInsets.top - safeAreaInsets.bottom,
    },
  };
};

export default getStyles;
